import { capitalizeStringUtil } from 'packages/src'
import { ListRowItemImage } from 'components/ListRowItem/Image'
import PressableRow from 'components/RowPressable'
import SectionItems from 'components/Section/Section.Items'
import TextBody from 'components/TextBody'
import TextBodySmall from 'components/TextBodySmall'
import TextTitleCompressedLight from 'components/TextTitleCompressedLight'
import { View } from 'components/View'
import SearchInput from 'pages/Search/Input'
import canBeAPosterMotivationUtil from 'models/daos/motivation/utils/can-be-a-poster'
import REDUX_OPTION from 'modules/redux/constants/option'
import getIdReduxUtil from 'modules/redux/utils/get-id'
import getValueReduxUtil from 'modules/redux/utils/get-value'
import getLocationRouterSelect from 'modules/router/selectors/get-location'
import {
  ROUTE,
  ROUTE_PATH
} from 'modules/routes/constants/index.cjs'
import interpolateRouteUtil from 'modules/routes/utils/interpolate'
import loadSectionAction from 'modules/section/actions/load'
import { getSearchedItemsSectionSelector } from 'modules/section/selectors/get-searched-items'
import { SECTIONS_NAME } from 'modules/sections/constants/index.cjs'
import { STYLES_MARGIN } from 'modules/styles/constants/index.cjs'
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { createSelector } from 'reselect'
import updateSearchAction from 'modules/search/actions/update-search'
import getQuerySearchSelect from 'modules/search/selectors/get-query'

const queryString = require('query-string')

const BATCH_COUNT = 30

const SEARCH_TAG_EXAMPLES = [
  'consistency',
  'mind',
  'body',
  'change',
  'progress',
  'goal'
]

class ProductPosterSearchComponent extends React.Component {
  constructor (props) {
    super(props)
    this.handleSubmitSearch = this.handleSubmitSearch.bind(this)
    this.handleLoadMoreItems = this.handleLoadMoreItems.bind(this)
    this.handlePressTagSearch = this.handlePressTagSearch.bind(this)
    this._offset = 0
    props.dispatch(updateSearchAction(''))
  }

  componentDidMount () {
    this.loadItems()
  }

  loadItems () {
    this.props.dispatch(loadSectionAction(ROUTE[ROUTE_PATH.MOTIVATION], null, {
      query: {
        query: this.props.query,
        offset: this._offset,
        limit: BATCH_COUNT,
        expand: 'tags'
      },
      [REDUX_OPTION.FORCED]: true
    }))
  }

  handlePressTagSearch (tag) {
    this.props.dispatch(updateSearchAction(tag))
  }

  handleSubmitSearch () {
    this._offset = 0
    this.loadItems()
  }

  handleLoadMoreItems () {
    this._offset += BATCH_COUNT
    this.loadItems()
  }

  renderItems () {
    const {
      items,
      query
    } = this.props
    if (!items.length && query) {
      return (
        <TextBody
          style={{
            marginTop: STYLES_MARGIN.SMALL
          }}
        >
          No Poster Found
        </TextBody>
      )
    } else if (!items.length) {
      return
    }

    return (
      <View>
        <SectionItems
          direction={SectionItems.DIRECTION.ROW}
          shouldScroll
          shouldNotWrap
          isBoundToWindow={false}
          onLoadMoreItems={this.handleLoadMoreItems}
        >
          {items.map((item, index) => {
            const style = {
              width: '13.88em'
            }
            if (!index) {
              style.marginLeft = '-1.5rem'
            }
            return (
              <div
                key={getIdReduxUtil(item)}
                style={style}
              >
                <ListRowItemImage
                  title={getValueReduxUtil(item, 'title')}
                  image={getValueReduxUtil(item, 'img')}
                  url={interpolateRouteUtil(this.props.location.pathname) +
                      `?${queryString.stringify({
                        option: getValueReduxUtil(item, 'slug')
                      })}`}
                />
              </div>
            )
          }
          )}
        </SectionItems>
      </View>
    )
  }

  renderInput () {
    return (
      <div
        style={{
          marginBottom: STYLES_MARGIN.SMALL
        }}
      >
        <SearchInput
          onSubmit={this.handleSubmitSearch}
        />
      </div>
    )
  }

  renderSearchTagExamples () {
    return (
      <View
        pb={2}
        style={{
          flexDirection: View.DIRECTION.ROW,
          overflowX: 'scroll',
          wordBreak: 'keep-all'
        }}
      >
        {SEARCH_TAG_EXAMPLES.map(tag => {
          return (
            <PressableRow
              key={tag}
              onClick={() => this.handlePressTagSearch(tag)}
              style={{
                marginRight: STYLES_MARGIN.SMALL,
                width: 'auto'
              }}
              isSelected={this.props.query === tag}
            >
              {capitalizeStringUtil(tag)}
            </PressableRow>
          )
        })}
      </View>
    )
  }

  renderTitle () {
    return (
      <TextTitleCompressedLight
        pb
      >
        Search your favorite quote
      </TextTitleCompressedLight>
    )
  }

  renderHighQualityText () {
    return (
      <TextBodySmall
        style={{
          marginTop: STYLES_MARGIN.SMALL
        }}
      >
        We will use the high quality version to print the poster.
      </TextBodySmall>
    )
  }

  renderPlaceholderImageText () {
    return (
      <TextBodySmall
        style={{
          marginTop: STYLES_MARGIN.SMALL
        }}
      >
        Once you add it to your cart, you will see the “consistency” poster added with the “option” set to the quote you chose. e.g. “Option: Mindset-is-everything”
      </TextBodySmall>
    )
  }

  render () {
    return (
      <View>
        {this.renderTitle()}
        {this.renderInput()}
        <TextTitleCompressedLight py>
          Or pick a popular search term
        </TextTitleCompressedLight>
        {this.renderSearchTagExamples()}
        {this.renderItems()}
        {this.renderHighQualityText()}
        {this.renderPlaceholderImageText()}
      </View>
    )
  }
}

ProductPosterSearchComponent.propTypes = {
  dispatch: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  query: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.object).isRequired
}

const getItemsSelector = () => createSelector(
  getSearchedItemsSectionSelector(SECTIONS_NAME.MOTIVATION),
  items => {
    return items.filter(item => {
      return canBeAPosterMotivationUtil(item)
    })
  }
)

const select = () => createSelector(
  getItemsSelector(),
  getLocationRouterSelect,
  getQuerySearchSelect,
  (items, location, query) => (
    {
      items,
      location,
      query
    }
  )
)

const ProductPosterSearch = connect(select)(ProductPosterSearchComponent)

export default ProductPosterSearch
